const styles = () => ({
  root: {
    height: "90vh",
    margin: "auto",
    width: "100%",
    //backgroundColor: "#000"
  },
  rootFullScreen: {
    height: "100vh",
    margin: "auto",
    width: "100%",
  },
});

export default styles;
